<script setup>
import { usePage } from '@inertiajs/vue3'
import { Modal, Select } from '@codinglabsau/ui'
import { useLocaleModal } from '@/Composables/useLocaleModal.js'
import { FormBuilder, useSchema } from '@codinglabsau/inertia-form-builder'

const { showLocaleModal } = useLocaleModal()

const emit = defineEmits(['close'])

const supportedLanguages = usePage().props.supported_languages
  ? Object.entries(usePage().props.supported_languages).map(([id, name]) => ({ id, name }))
  : []

const supportedCurrencies = usePage().props.supported_currencies?.map(currency => ({
  id: currency,
  name: currency,
}))

const localeSchema = useSchema({
  language: {
    component: Select,
    value: usePage().props.session.language ?? 'en',
    description: __('Please note non-English language support is experimental.'),
    props: {
      options: supportedLanguages,
    },
  },
  currency: {
    component: Select,
    value: usePage().props.session.currency_code,
    description: __('Prices and payments are always calculated in :base_currency_code. The selected currency will be utilised to display estimated prices on certain pages of the website where indicated.', { base_currency_code: usePage().props.tenant.settings.currency_code }),
    props: {
      options: supportedCurrencies,
    },
  },
})

const submit = () => {
  localeSchema.form.post(route('locale-settings.update'), {
    onSuccess: () => emit('close'),
  })
}
</script>

<template>
  <Modal :open="showLocaleModal" @close="emit('close')">
    <template #header> {{ __('Language and Currency Settings') }}</template>

    <form @submit.prevent="submit">
      <FormBuilder :schema="localeSchema" />
    </form>
  </Modal>
</template>
